import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, switchMap } from 'rxjs/operators';
import { ACCESS_TOKEN } from '../constants';
import { AuthService } from '../services/auth.service';
import { JwtService } from '../services/jwt.service';
import { LoadingService } from '../services/loading.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  
  constructor(
    private readonly authService: AuthService,
    private readonly jwtService: JwtService,
    private readonly router: Router,
    private readonly loadingService: LoadingService
  ) { }

  intercept<T>(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    const accessToken = localStorage.getItem(ACCESS_TOKEN);
    this.loadingService.show();

    if (accessToken && !this.jwtService.isTokenExpired(accessToken)) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
    }

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && !req.headers.has('Authorization-Retry')) {
        return this.authService.refreshToken().pipe(
        switchMap(() => {
          const newAccessToken = localStorage.getItem(ACCESS_TOKEN);
          if (newAccessToken) {
          const clonedRequest = req.clone({
            setHeaders: {
            Authorization: `Bearer ${newAccessToken}`,
            'Authorization-Retry': 'true',
            },
          });
          return next.handle(clonedRequest);
          }
          return throwError(() => error);
        }),
        catchError(() => {
          return throwError(() => error);
        })
        );
      }
 
      return throwError(() => error);
      }),
      finalize(() => this.loadingService.hide())
    );
  }
}